import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearCanvas, resetCanvas } from "../../../redux/slices/userActivity";

export default function ResetCanvas() {
  const { selectedUserActivity, userActivities, history } = useSelector((state) => state.userActivity);

  const dispatch = useDispatch();

  const handleClear = () => dispatch(clearCanvas());

  const handleReset = () => dispatch(resetCanvas());

  return (
    <div className="reset-canvas center-y editor-right">
      <div className="d-flex icon" style={{ cursor: "pointer" }} onClick={handleReset}>
        <img src="/assets/icons/reset.svg" />
      </div>
      <button onClick={handleClear}>Clear Canvas</button>
    </div>
  );
}
